import sortBy from 'lodash/sortBy';

const initialState = {
  balance: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_BALANCE': {
      return {
        ...state,
        ...payload,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/Balance/Balance.reducer.js